
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/something-new-is-coming",
      function () {
        return require("private-next-pages/something-new-is-coming.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/something-new-is-coming"])
      });
    }
  